import { render, staticRenderFns } from "./manageRedirectQr.vue?vue&type=template&id=dcb36d22&scoped=true"
import script from "./manageRedirectQr.vue?vue&type=script&lang=js"
export * from "./manageRedirectQr.vue?vue&type=script&lang=js"
import style0 from "./manageRedirectQr.vue?vue&type=style&index=0&id=dcb36d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb36d22",
  null
  
)

export default component.exports